export const PIN_CODE = '5623';
export const PIN_STORAGE_KEY = 'provider_pin_auth';
export const PIN_ATTEMPTS_KEY = 'provider_pin_attempts';
export const MAX_PIN_ATTEMPTS = 3;
export const PIN_VALIDITY_DAYS = 30;

export const checkPinValidity = () => {
  try {
    const stored = localStorage.getItem(PIN_STORAGE_KEY);
    if (!stored) return false;
    const { timestamp } = JSON.parse(stored);
    const expiry = new Date(timestamp);
    expiry.setDate(expiry.getDate() + PIN_VALIDITY_DAYS);
    return new Date() < expiry;
  } catch {
    return false;
  }
};

export const savePinAuth = () => {
  localStorage.setItem(PIN_STORAGE_KEY, JSON.stringify({ timestamp: new Date().toISOString() }));
  localStorage.removeItem(PIN_ATTEMPTS_KEY);
};

export const getPinAttempts = () => {
  try {
    const stored = localStorage.getItem(PIN_ATTEMPTS_KEY);
    if (!stored) return 0;
    return JSON.parse(stored).attempts || 0;
  } catch {
    return 0;
  }
};

export const incrementPinAttempts = () => {
  const current = getPinAttempts();
  localStorage.setItem(PIN_ATTEMPTS_KEY, JSON.stringify({ attempts: current + 1 }));
  return current + 1;
};
